import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ShoppingBagIcon, SparklesIcon, ShieldCheckIcon, ArrowRightIcon } from 'lucide-react';
import { ShopFramesModal } from './ShopFramesModal';
export function ShopFramesSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <section className="py-20 md:py-28 bg-brand-dark text-white relative overflow-hidden" data-id="element-592">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-593">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] mix-blend-overlay" data-id="element-594"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-595">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-596">
          {/* Content */}
          <div className="lg:w-1/2 text-center lg:text-left" data-id="element-597">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-3xl md:text-5xl font-heading font-bold mb-6 leading-tight" data-id="element-598">
              <span className="text-white" data-id="element-599">Shop Designer Frames Online</span>
            </motion.h2>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-lg text-white/80 mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-600">
              Browse our extensive collection of premium eyewear from the
              comfort of your home. Select your local clinic to view their
              specific inventory and find the perfect frames for your style.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start" data-id="element-601">
              <button onClick={() => setIsModalOpen(true)} className="w-full sm:w-auto bg-brand-gold hover:bg-brand-gold-light text-white px-8 py-4 rounded-button font-heading font-semibold text-lg transition-colors shadow-lg focus-ring flex items-center justify-center gap-2" data-id="element-602">
                <ShoppingBagIcon className="w-5 h-5" data-id="element-603" />
                Shop Frames Now
              </button>

              <div className="flex items-center gap-2 text-white/60 text-sm mt-4 sm:mt-0" data-id="element-604">
                <ShieldCheckIcon className="w-4 h-4 text-brand-gold" data-id="element-605" />
                <span data-id="element-606">Secure online browsing</span>
              </div>
            </motion.div>
          </div>

          {/* Image Grid */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="lg:w-1/2 w-full" data-id="element-607">
            <div className="relative" data-id="element-608">
              {/* Decorative elements */}
              <div className="absolute -inset-4 bg-brand-gold/20 blur-2xl rounded-full opacity-50" data-id="element-609"></div>

              <div className="relative grid grid-cols-2 gap-4" data-id="element-610">
                <div className="space-y-4 mt-8" data-id="element-611">
                  <img src="https://images.unsplash.com/photo-1511499767150-a48a237f0083?auto=format&fit=crop&q=80&w=600" alt="Stylish sunglasses" className="w-full h-48 object-cover rounded-2xl shadow-lg border border-white/10" data-id="element-612" />
                  <img src="https://images.unsplash.com/photo-1591076482161-42ce6da69f67?auto=format&fit=crop&q=80&w=600" alt="Classic frames" className="w-full h-64 object-cover rounded-2xl shadow-lg border border-white/10" data-id="element-613" />
                </div>
                <div className="space-y-4" data-id="element-614">
                  <img src="https://images.unsplash.com/photo-1574258495973-f010dfbb5371?auto=format&fit=crop&q=80&w=600" alt="Modern eyewear" className="w-full h-64 object-cover rounded-2xl shadow-lg border border-white/10" data-id="element-615" />
                  <img src="https://images.unsplash.com/photo-1509695507497-903c140c43b0?auto=format&fit=crop&q=80&w=600" alt="Designer glasses" className="w-full h-48 object-cover rounded-2xl shadow-lg border border-white/10" data-id="element-616" />
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      <ShopFramesModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-617" />
    </section>;
}